export const invoiceBalanced = ({ context }) => !!context.invoiceBalanced;
export const paymentReceived = ({ context }) => !!context.paymentReceived;
//# sourceMappingURL=invoice.js.map